// extracted by mini-css-extract-plugin
export var button = "_d9-4";
export var hasDarkBackground = "_d9-7";
export var hasLightBackground = "_d9-6";
export var iconWrapper = "_d9-0";
export var large = "_d9-2";
export var medium = "_d9-1";
export var small = "_d9-5";
export var xsmall = "_d9-3";